var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styles from './action-item-add-button.module.scss';
import { Button } from '@app/Components/Button/Button';
var ActionItemAddButton = /** @class */ (function (_super) {
    __extends(ActionItemAddButton, _super);
    function ActionItemAddButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionItemAddButton.prototype.render = function () {
        var _a = this.props, projectId = _a.projectId, disabled = _a.disabled, onClick = _a.onClick;
        return (React.createElement("div", { className: styles.actionItemWrapper },
            React.createElement("div", { className: styles.tableTitle }, "Action items"),
            React.createElement(Button, { key: projectId, size: "sm", disabled: disabled, onClick: onClick, className: styles.createActionItemButton }, "Add Action Item")));
    };
    return ActionItemAddButton;
}(React.PureComponent));
export { ActionItemAddButton };
